import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/(main)/institutional/page.tsx");
